var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoyalArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5119 0L0 39.5782H32.8857L16.5119 0ZM16.5119 4.14909L22.591 19.5442L16.5119 25.4387L10.4888 19.5442L16.5119 4.14909ZM10.0186 20.7878L16.5022 27.1896L22.99 20.7694L29.4929 37.5667H3.52108L10.0186 20.7878Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3549 18.0269C18.0766 17.5294 17.3767 16.9972 17.3767 16.9972C18.2039 16.9972 18.9577 16.1087 18.8833 14.927C18.811 13.792 17.8707 13.2261 16.9788 13.2261H15.4722C15.126 13.2261 14.8823 13.2261 14.8823 13.2261H14.2892V20.1937H15.4733V17.398C16.1635 17.398 16.5959 17.4425 16.8936 17.8954C17.1923 18.3516 18.2934 20.1937 18.2934 20.1937H19.69C19.69 20.1937 18.6363 18.5243 18.3549 18.0269ZM16.5399 16.427H15.4722V14.1732C15.4722 14.1732 15.9047 14.1732 16.4363 14.1732C16.9648 14.1732 17.6269 14.4393 17.6269 15.1583C17.6269 15.8741 17.1567 16.427 16.5399 16.427Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalArtist);
export default __webpack_public_path__ + "static/media/RoyalArtist.eb6808c18ce54600a55754e03b315436.svg";
export { ForwardRef as ReactComponent };